import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Table, Row, Col, TreeSelect, Spin, Badge } from "antd";
import { Link } from "react-router-dom";
import Button from "antd-button-color"; //npm install antd-button-color  || https://www.npmjs.com/package/antd-button-color
import { GetTypeQuestionApi } from "api/getQuiz";
import { GetGroupISMSUserApi } from "api/getGroup";
import {
  errorHandle,
  return_filter_team,
} from "../../../Function";
// import "./ViewQuestion.css";
import ModalCreateGroup from "./ModalGroup/ModalCreateGroup";
// import ModalCreateQuiz from "./ModalQuiz/ModalCreateQuiz";
import {
  AppstoreAddOutlined,
  EditOutlined,
  GroupOutlined,
  UngroupOutlined,
} from "@ant-design/icons";
import { ListBoPhanApi } from "api/getListTeam";
import EditUserGroup from "./ModalUserGroup/EditUserGroup";
import ModalEditGroup from "./ModalGroup/ModalEditGroup";

const getColumns = ({ pager, onShowModalUserGroup }) => [
  {
    title: "STT",
    dataIndex: "index",
    key: "index",
    align: "center",
    render: (value, item, index) =>
      ((pager.current || 1) - 1) * pager.pageSize + index + 1,
    sortDirections: ["descend", "ascend", "descend"],
    ellipsis: true,
    width: 50,
    fixed: "left",
  },
  {
    title: "Nhân viên",
    dataIndex: "username",
    key: "username",
    filterKey: "username",
    type: "text",
    width: 150,
    render: (text, record) => record.msnv + "-" + text,
  },
  {
    title: "Họ và tên",
    dataIndex: "username",
    key: "username",
    filterKey: "username",
    type: "text",
    width: 190,
    render: (text, record) => record.last_name + " " + record.first_name,
  },
  {
    title: "Team",
    dataIndex: "fore_team__tenTeam",
    className: "highlight",
    key: "fore_team__tenTeam",
    filterKey: "fore_team__tenTeam",
    type: "text",
    width: 100,
  },
  {
    title: "Nhóm thi",
    dataIndex: "data_group_isms",
    key: "data_group_isms",
    filterKey: "data_group_isms",
    type: "text",
    render: (item, record) => (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "12px",
          maxHeight: "300px",
          overflowY: "auto",
        }}
      >
        {item.map((group, index) => (
          <div key={index}>🔹 {group.note}</div>
        ))}
      </div>
    ),
  },
  {
    title: "Thao tác",
    dataIndex: "",
    className: "highlight",
    key: "",
    filterKey: "",
    type: "text",
    align: "center",
    width: 100,
    render: (text, record) =>
      getBtnAction({
        record,
        onShowModalUserGroup,
      }),
    canSearch: true,
  },
];

const getBtnAction = ({ record, onShowModalUserGroup }) => {
  return (
    <>
      <Row>
        <Col span={24}>
          {/* {record.data_group_isms.length !== 0 && ( */}
          <span
            title="Chỉnh sửa"
            className={"col-6"}
            style={{ color: "#4290d3", cursor: "pointer" }}
            onClick={() => onShowModalUserGroup(record)}
          >
            <EditOutlined />
          </span>
          {/* )} */}
        </Col>
      </Row>
    </>
  );
};

const ViewGroup = () => {
  const defaultPageSize = 10;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loading_page, setLoading_page] = useState(false);
  const [arrTypeQuestion, setArrTypeQuestion] = useState([]);
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [isShowCreateGroup, setIsShowCreateGroup] = useState(false);
  const [isShowUserGroup, setIsShowUserGroup] = useState(false);
  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [detailUser, setDetailUser] = useState([]);
  const [isShowAddTeamGroup, setIsShowAddTeamGroup] = useState(false);
  const [isTypeAdd, setIsTypeAdd] = useState(false);
  const [isShowEditGroup, setIsShowEditGroup] = useState(false);

  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const fetchDataUser = (params = {}) => {
    setLoading(true);
    GetGroupISMSUserApi(params)
      .then((res) => {
        setData(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchTypeQs = (params = {}) => {
    setLoading(true);
    GetTypeQuestionApi(params)
      .then((res) => {
        setArrTypeQuestion(res.data.results);
        setLoading(false);
      })
      .catch((err) => {
        errorHandle(err);
        setLoading(false);
      });
  };

  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      if (res.data.length > 0) {
        var data_curr_bp = res.data.filter((x) => x.team.length !== 0);
        setCurrentBoPhan([data_curr_bp[0].id]);
        setLsBoPhan(data_curr_bp);

        if (currentTeam.length === 0) {
          var data_curr_team = data_curr_bp[0].team[0];
          setCurrentTeam([data_curr_team.id]); // 200423 lấy element đầu tiên đặt trong list
        }
      }

      var uniqueArrTeam = return_filter_team([data_curr_bp[0]]);
      uniqueArrTeam.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });

      setLsTeam(uniqueArrTeam);
    });
  };

  useEffect(() => {
    fetchTypeQs();
    fetchListTeam();
  }, []);

  // useEffect(() => {
  //   fetchDataQuiz({
  //     question_type: selectedGroup,
  //   });
  // }, [selectedGroup]);

  const onCancelCreateGroup = () => {
    setIsShowCreateGroup(false);
    fetchTypeQs();
  };

  useEffect(() => {
    if (currentTeam.length > 0) {
      fetchDataUser({ idTeam: JSON.stringify(currentTeam) });
    }
    if (currentTeam.length === 0) {
      setData([]);
    }
  }, [currentTeam]);

  // useEffect(() => {
  //   if (userInfo.team_permissions.length === 0) {
  //     openNotificationWithIcon("error", "Bạn chưa có quyền cho team.");
  //   }
  //   if (
  //     userInfo &&
  //     userInfo.team_permissions &&
  //     userInfo.team_permissions.length > 0
  //   ) {
  //     fetchListTeam();
  //   }
  // }, [userInfo]);

  const onChangeBoPhan = (value) => {
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = return_filter_team(
        lsBoPhan.filter((x) => value.includes(x.id))
      );
      lsTeamWith_BP.sort(function (first, second) {
        return first["idTeam"] - second["idTeam"];
      });

      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]);
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };

  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  const onChangeTeam = (value) => {
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  setCurrentTeam([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  setCurrentTeam(lsTeam.map((item) => item.idTeam));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    treeCheckable: true,
    maxTagCount: 2,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };
  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  const onShowModalUserGroup = (record) => {
    setIsShowUserGroup(true);
    setIsTypeAdd(false);
    setDetailUser(record);
  };

  const onCancelUserGroup = () => {
    setIsShowUserGroup(false);
  };

  const onShowAddTeamGroup = () => {
    setIsShowUserGroup(true);
    setIsTypeAdd(true);
    setDetailUser([]);
  };

  const onShowEditGroup = () => {
    setIsShowEditGroup(true);
    setDetailUser([]);
  };

  const onCancelEditGroup = () => {
    setIsShowEditGroup(false);
  };

  const columns = getColumns({ pager, onShowModalUserGroup });

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">Nhóm thi</h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <Link to="#">ISMS</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/isms/question">Nhóm thi</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <Row
          // gutter={[8, 8]}
          style={{ float: "left" }}
        >
          <Col>
            {/* <div className="sl-group m-2"> */}
            <div className="styleBadge m-2">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
          </Col>
          <Col>
            <Button
              ghost
              type="success"
              className={"m-2"}
              onClick={() => setIsShowCreateGroup(true)}
              icon={<GroupOutlined />}
            >
              Tạo nhóm
            </Button>
          </Col>
          <Col>
            <Button
              ghost
              type="success"
              className={"m-2"}
              onClick={onShowEditGroup}
              icon={<UngroupOutlined />}
            >
              Chỉnh sửa nhóm thi
            </Button>
          </Col>
          <Col>
            <Button
              ghost
              type="primary"
              className={"m-2"}
              onClick={onShowAddTeamGroup}
              icon={<AppstoreAddOutlined />}
            >
              Gán nhóm thi
            </Button>
          </Col>
        </Row>
      </div>
      <Spin spinning={loading_page}>
        <div className="row justify-content-center">
          <div
            className="col-auto"
            // style={{ maxWidth: "1000px", overflowX: "auto" }}
          >
            <Table
              dataSource={data}
              columns={columns}
              loading={loading}
              className={"custom-table-hover style-6"}
              bordered={true}
              size={"small"}
              rowKey="id"
              pagination={false}
            />
          </div>
        </div>
      </Spin>
      {isShowCreateGroup && (
        <ModalCreateGroup
          open={isShowCreateGroup}
          onCancel={onCancelCreateGroup}
          arrTypeQuestion={arrTypeQuestion}
        />
      )}

      {isShowUserGroup && (
        <EditUserGroup
          open={isShowUserGroup}
          onCancel={onCancelUserGroup}
          detailUser={detailUser}
          arrTypeQuestion={arrTypeQuestion}
          fetchDataUser={fetchDataUser}
          currentTeam={currentTeam}
          lsTeam={lsTeam}
          isTypeAdd={isTypeAdd}
        />
      )}
      {isShowEditGroup && (
        <ModalEditGroup
          open={isShowEditGroup}
          onCancel={onCancelEditGroup}
          arrTypeQuestion={arrTypeQuestion}
          fetchDataUser={fetchDataUser}
          currentTeam={currentTeam}
          fetchTypeQs={fetchTypeQs}
        />
      )}
    </>
  );
};

export default ViewGroup;
